import React from 'react';

import MessageCampaignContentPreviewCard from 'components/message/MessageCampaignContentPreviewCard';
import { CAMPAIGN_PAGE_ANCHOR_KEY } from 'config/CustomEnums';

export const MESSAGE_CAMPAIGN_DETAIL_PAGE_CONFIG = {
  extraValidate: () => true,
  getDisplayComponentKeys: ({ detailData }) => {
    const displayLanguageSectionComponents = [
      'campaign_content_section_key',
    ];
    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents,
    };
  },
  normalSections: [],
  languageExtraTopSection: () => (
    <div id={CAMPAIGN_PAGE_ANCHOR_KEY.contentPage} />
  ),
  languageSections: [
    {
      sectionContent: [
        {
          key: 'campaign_content_section_key',
          complexComponent: ({ detailData, language }) => (
            <MessageCampaignContentPreviewCard
              language={language}
              campaignData={detailData}
              hideEditButton
            />
          ),
        },
      ],
    },
  ],
};
